
import {
  app
} from '../constants';

/**
 * Import constants
 */
const {
  SET_PROJECT,
  SET_DISTRICT,
  SET_LANG,
  SET_UUID,
  SET_LOCALITY,
  SET_DISTRICTS,
  SET_PLUGINID,
} = app;


/**
 * Action creators
 */
const actions = {
  setProject: (data) => ({ type: SET_PROJECT, data }),
  setDistrict: (data) => ({ type: SET_DISTRICT, data }),
  setLang: (data) => ({ type: SET_LANG, data }),
  setUuid: (data) => ({ type: SET_UUID, data }),
  setLocality: (data) => ({ type: SET_LOCALITY, data }),
  setDistricts: (data) => ({ type: SET_DISTRICTS, data }),
  setPluginId: (data) => ({ type: SET_PLUGINID, data }),
};


/**
 * Set project id
 */
export const setProjectId = (projectId) => (dispatch) => dispatch(actions.setProject(projectId));


/**
 * Set district id
 */
export const setDistrictId = (districtId) => (dispatch) => {
  dispatch(actions.setDistrict(districtId));
};


/**
 * Set district id
 */
export const setDistricts = (districts) => (dispatch) => {
  dispatch(actions.setDistricts(districts));
};


/**
 * Set lang
 */
export const setLanguage = (lang) => (dispatch) => dispatch(actions.setLang(lang));


/**
 * Set uuid
 */
export const setUuid = (uuid) => (dispatch) => dispatch(actions.setUuid(uuid));


/**
 * Set locality
 */
export const setLocality = (uuid) => (dispatch) => dispatch(actions.setLocality(uuid));

/**
 * Set plugin Id
 */
export const setPluginId = (pluginId) => (dispatch) => dispatch(actions.setPluginId(pluginId));
